import React from "react";
import { ExpandableHeader } from "../../../../../components/ACS-Dashboard/ACS-Blocks/ExpandableHeader";
import { ShipmentDisplayDetail as DisplayDetail } from "../shipmentShared";
import { Package } from "lucide-react";

export default function ShipmentItems({
  items = [],
  setSectionRef,
  PACKAGE_TYPE_MAP,
}) {
  return (
    <>
      <h3
        ref={setSectionRef("Items")}
        className="text-fluid-lg font-semibold mb-fluid-2"
      >
        Items
      </h3>

      {items?.map((item, index) => {
        const itemEntries = [
          { label: "Product Code", value: item.itemProductCode },
          { label: "Description", value: item.itemDescription },
          {
            label: "Package Type",
            value: PACKAGE_TYPE_MAP[item.containerType1] || item.containerType1,
          },
          { label: "Package Quantity", value: item.quantity1 },
          { label: "Handling Container Type", value: item.containerType2 },
          { label: "Handling Quantity", value: item.quantity2 },
          {
            label: "Total Weight",
            value: item.totalWeight
              ? `${item.totalWeight} ${item.unitOfMeasurement}`
              : null,
          },
          {
            label: "Total Volume",
            value: item.totalVolume
              ? `${item.totalVolume} ${item.volumeUnit || ""}`.trim()
              : null,
          },
          { label: "Weight Qualifier", value: item.weightQualifier },
          { label: "Sales Order Number", value: item.salesOrderNumber },
        ];

        return (
          <ExpandableHeader
            key={item.id}
            headerSection={`Item #${index + 1}`}
            headerLabel={item.itemProductCode}
            icon={Package}
            headerType="success"
            initiallyExpanded={false}
          >
            <div
              className="
                grid grid-cols-5 gap-x-fluid-2 gap-y-fluid-3
                p-fluid-3
                bg-[#F9FAFE] dark:bg-acs-dark-surface
                text-gray-800 dark:text-acs-dark-text
              "
            >
              {itemEntries.map((entry, idx) => (
                <DisplayDetail key={idx} label={entry.label} value={entry.value} />
              ))}
            </div>
          </ExpandableHeader>
        );
      })}
    </>
  );
}
